/*
* 一些通用业务方法
* */

import { request } from './request';
import { BOM } from './BOM';

const LIVETYPEFVEDIO = 1; //视频
const LIVETYPEAUTIO = 0; //音频
const GUILDCONTRACTTYPE = 3;
const GUILDANCHORTYPE = 3;
const ANCHORTYPEOFFICIAL = 1; //签约主播
const ANCHORTYPEGUILDLEADER = 2; //工会长
const ANCHORTYPEGUILD = 3; //工会主播
//取得筛选项
function getFilterItems(cb) {
    request({
        url: '/x/live/web_config',
        callback: d => {
            if (d.err_code === 0) {
                cb(d.data['ja']);
            }
        }
    });
}

//筛选项 value === > name
function createNameFromValueFunction(items) {
    const _items = items;
    return function(key, value) {
        const item = _items[key];
        if (item instanceof Array) {
            const final = item.filter(v => {
                return v.value === value;
            });
            if (final.length > 0) {
                return final[0].name;
            } else {
                return '';
            }
        }
        return '';
    };
}

//根据display_id 取得 userinfo
function getUserInfoByDisplayId(display_id) {
    if (display_id.trim() === '') return;
    return new BOM.window.Promise(async resolvef => {
        const data = await new BOM.window.Promise(resolve => {
            request({
                url: '/api/user/transform/d2u?id=' + display_id,
                callback: d => {
                    resolve(d);
                }
            });
        });
        if (data.err_code === 0 && data.data.data) {
            request({
                url: '/x/user/profile?t_uid=' + data.data.data[display_id],
                callback: d => {
                    resolvef(d);
                }
            });
        } else {
            resolvef(null);
            //BOM.alert(data.err_msg);
        }
    });
}

//当前登录用户的info
function getMyUserInfo() {
    return new BOM.window.Promise(resolve => {
        request({
            url: '/x/user/my_info',
            needNetworkError: false,
            log: false,
            callback: d => {
                if (d.err_code === 0 && d.data.user) {
                    d.data.user.member = d.data.member || {};
                    resolve(d.data.user);
                } else {
                    resolve(null);
                }
            }
        });
    });
}

function getGiftResources(gift_ids) {
    return new BOM.window.Promise(resolve => {
        const data = {};
        if (gift_ids) {
            data.gift_ids = gift_ids;
        }
        request({
            url: '/x/gift',
            data: data,
            callback: d => {
                if (d.err_code === 0 && d.data.resource) {
                    resolve(d.data.resource);
                } else {
                    resolve(null);
                }
            }
        });
    });
}

function getConfig() {
    return new BOM.window.Promise(resolve => {
        request({
            url: '/x/config/rctext',
            data: {
                name: 'global_config'
            },
            callback: d => {
                if (d.err_code === 0) {
                    resolve(d.data.global_config);
                } else {
                    resolve(null);
                }
            }
        });
    });
}

export {
    getFilterItems,
    createNameFromValueFunction,
    LIVETYPEFVEDIO,
    LIVETYPEAUTIO,
    GUILDCONTRACTTYPE,
    GUILDANCHORTYPE,
    getUserInfoByDisplayId,
    getMyUserInfo,
    ANCHORTYPEOFFICIAL,
    ANCHORTYPEGUILDLEADER,
    ANCHORTYPEGUILD,
    getGiftResources,
    getConfig
};
